define("calendar/components/calendar/stories/full-calendar", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@fullcalendar/core", "@fullcalendar/core/locales/es", "ember-concurrency-decorators", "ember-concurrency-ts", "perfect-scrollbar", "moment-timezone", "later/helpers/profile-color-outline-class", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _object, _computed, _service, _utils, _core, _es, _emberConcurrencyDecorators, _emberConcurrencyTs, _perfectScrollbar, _momentTimezone, _profileColorOutlineClass, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _updateCalendarDates, _checkValidProfiles;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@fullcalendar/core",0,"@fullcalendar/core/locales/es",0,"ember-concurrency-decorators",0,"ember-concurrency-ts",0,"perfect-scrollbar",0,"moment-timezone",0,"later/helpers/profile-color-outline-class",0,"later/utils/constants",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div 
    {{did-insert this.createCalendar}}
    {{did-update this.updateEvents this.profiles this.cachedData}}
    id="stories-calendar" 
    class="eCA--stories cCA--calendar--timeline">
  </div>
  
  */
  {
    "id": "rrDz1ylg",
    "block": "[[[11,0],[24,1,\"stories-calendar\"],[24,0,\"eCA--stories cCA--calendar--timeline\"],[4,[38,0],[[30,0,[\"createCalendar\"]]],null],[4,[38,1],[[30,0,[\"updateEvents\"]],[30,0,[\"profiles\"]],[30,0,[\"cachedData\"]]],null],[12],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"did-insert\",\"did-update\"]]",
    "moduleName": "calendar/components/calendar/stories/full-calendar.hbs",
    "isStrictMode": false
  });

  const {
    WEEK,
    MONTH
  } = _constants.CALENDAR_VIEW_TYPES;
  const {
    STORIES
  } = _constants.CALENDAR_TYPES;
  const {
    POST
  } = _constants.CALENDAR_EVENT_TYPES;
  let StoriesFullCalendarComponent = (_dec = (0, _service.inject)('markup'), _dec2 = (0, _service.inject)('events'), _dec3 = (0, _service.inject)('config'), _dec4 = (0, _computed.readOnly)('auth.currentFirstDay'), _dec5 = (0, _computed.readOnly)('auth.currentUserModel'), _dec6 = (0, _computed.readOnly)('currentUserModel.timeZone'), _dec7 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), _dec8 = (0, _computed.readOnly)('selectedSocialProfiles.profiles'), _dec9 = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), _dec10 = (0, _computed.readOnly)('userConfig.currentTimeZone.name'), (_class = (_updateCalendarDates = /*#__PURE__*/new WeakSet(), _checkValidProfiles = /*#__PURE__*/new WeakSet(), class StoriesFullCalendarComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _checkValidProfiles);

      _classPrivateMethodInitSpec(this, _updateCalendarDates);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "locale", _descriptor5, this);

      _initializerDefineProperty(this, "router", _descriptor6, this);

      _initializerDefineProperty(this, "calendarMarkup", _descriptor7, this);

      _initializerDefineProperty(this, "calendarEvents", _descriptor8, this);

      _initializerDefineProperty(this, "calendarConfig", _descriptor9, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor10, this);

      _initializerDefineProperty(this, "userConfig", _descriptor11, this);

      _initializerDefineProperty(this, "errors", _descriptor12, this);

      _initializerDefineProperty(this, "firstDay", _descriptor13, this);

      _initializerDefineProperty(this, "currentUserModel", _descriptor14, this);

      _initializerDefineProperty(this, "timeZone", _descriptor15, this);

      _initializerDefineProperty(this, "socialProfile", _descriptor16, this);

      _initializerDefineProperty(this, "profiles", _descriptor17, this);

      _initializerDefineProperty(this, "timeZoneIdentifier", _descriptor18, this);

      _initializerDefineProperty(this, "timeZoneName", _descriptor19, this);
    }

    get cachedData() {
      return {
        cachePosts: this.args.posts
      };
    }

    get calendarTimeZone() {
      return (0, _utils.isNone)(this.timeZoneIdentifier) ? 'local' : this.timeZoneIdentifier;
    }

    get customButtons() {
      return {
        previewButton: {
          text: this.intl.t('calendar.views.preview'),
          click: () => this.args.viewPreviewGrid()
        },
        timezoneButton: {
          text: this.timeZoneName
        },
        storiesButton: {
          text: this.intl.t('calendar.views.stories'),
          click: () => undefined
        },
        weekButton: {
          text: this.intl.t('calendar.views.week'),
          click: () => this.args.viewWeekCalendar()
        },
        monthButton: {
          text: this.intl.t('calendar.views.month'),
          click: () => this.args.viewMonthCalendar()
        }
      };
    }

    createCalendar() {
      _classPrivateMethodGet(this, _checkValidProfiles, _checkValidProfiles2).call(this);

      this.calendarConfig.calendarType = STORIES;
      const calendarEl = document.getElementById('stories-calendar');

      if (!calendarEl) {
        return this.errors.log('Stories/FullCalendar: No calendar element found', {}, 'critical');
      }

      const calendar = new _core.Calendar(calendarEl, { ...this.calendarConfig.commonConfig,
        aspectRatio: 1.65,
        buttonIcons: {
          prev: 'left',
          next: 'right'
        },
        customButtons: this.customButtons,
        dayPopoverFormat: {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        },
        defaultTimedEventDuration: this.calendarEvents.defaultTimedEventDuration,
        droppable: false,
        editable: false,
        eventBorderColor: 'transparent',
        eventDurationEditable: false,
        firstDay: (0, _utils.isNone)(this.firstDay) ? 0 : this.firstDay,
        // If targetDate exists, set as initial date
        ...(this.args.targetDate && {
          initialDate: this.calendarConfig.handleLegacyDate(this.args.targetDate)
        }),
        initialView: WEEK,
        locales: [_es.default],
        locale: this.locale.primaryLocale,
        now: (0, _momentTimezone.default)().tz(this.calendarTimeZone).format(),
        views: {
          [WEEK]: {
            dayHeaderFormat: {
              weekday: 'short',
              day: 'numeric'
            },
            titleFormat: {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            },
            eventTimeFormat: {
              hour: 'numeric',
              minute: '2-digit',
              meridiem: false
            }
          },
          [MONTH]: {
            eventLimit: 2,
            eventTimeFormat: {
              hour: 'numeric',
              minute: '2-digit',
              meridiem: 'short'
            }
          }
        },
        eventContent: _ref2 => {
          let {
            event
          } = _ref2;
          const {
            extendedProps
          } = event;
          if (extendedProps.eventType !== POST) return;
          const eventContentWrapper = document.createElement('div');
          const postTimeContainer = document.createElement('div');
          const postContentContainer = document.createElement('div');
          const postIconContainer = document.createElement('div');
          const postElements = {
            postTimeContainer,
            postContentContainer,
            postIconContainer,
            eventContentWrapper
          };
          this.calendarMarkup.updateCommonPostMarkup(postElements, event);
          eventContentWrapper.appendChild(postTimeContainer);
          eventContentWrapper.appendChild(postContentContainer);
          eventContentWrapper.appendChild(postIconContainer);
          return {
            domNodes: [eventContentWrapper]
          };
        },
        eventDidMount: _ref3 => {
          let {
            el,
            event
          } = _ref3;
          const {
            extendedProps
          } = event;
          if (extendedProps.eventType !== POST) return;
          const {
            profileColorClass
          } = extendedProps;
          event.setProp('editable', false);
          event.setProp('allDay', false);
          event.setExtendedProp('profileColorClass', (0, _profileColorOutlineClass.profileColorOutlineClass)(profileColorClass));
          const postElement = el.parentElement;

          if (!postElement) {
            return this.errors.log('No post element found', {
              el,
              event,
              postElement
            });
          }

          postElement.classList.add('fc-post-harness');
        },
        viewDidMount: _ref4 => {
          let {
            view
          } = _ref4;
          this.calendarConfig.set('calendarView', view.type);
          const scrollContainer = document.querySelector('.fc-scrollgrid-section-body');

          if (!scrollContainer) {
            return this.errors.log('Stories/FullCalendar: No scroll container element found', {}, 'critical');
          }

          new _perfectScrollbar.default(scrollContainer);
        }
      });
      this.calendarConfig.set('fullCalendar', calendar);
      this.calendarConfig.set('calendarView', STORIES);
      calendar.render();
      this.calendarMarkup.updateStoriesButton();
      (0, _emberConcurrencyTs.taskFor)(this.calendarConfig.handleWithProgressBar).perform(() => {
        (0, _emberConcurrencyTs.taskFor)(this._addEventsToCalendar).perform(calendar);
      }); // Note: Remove and add event sources based on new dates, update dates for 'vis'

      calendar.on('datesSet', _ref5 => {
        let {
          start,
          end
        } = _ref5;
        return (0, _emberConcurrencyTs.taskFor)(this.calendarConfig.handleWithProgressBar).perform(() => {
          (0, _emberConcurrencyTs.taskFor)(this._handleDateSet).perform(start, end);
        });
      });
    }

    updateEvents() {
      (0, _emberConcurrencyTs.taskFor)(this._updateEvents).perform();
    }

    *_addEventsToCalendar(calendar) {
      _classPrivateMethodGet(this, _updateCalendarDates, _updateCalendarDates2).call(this, calendar.view.activeStart, calendar.view.activeEnd);

      const events = yield (0, _emberConcurrencyTs.taskFor)(this._fetchPostEvents).perform();
      calendar.removeAllEvents();
      yield calendar.addEventSource(events);
    }

    *_handleDateSet(start, end) {
      yield (0, _emberConcurrencyTs.taskFor)(this._updateEvents).perform({
        start,
        end
      });

      _classPrivateMethodGet(this, _updateCalendarDates, _updateCalendarDates2).call(this, start, end);
    }

    *_updateEvents() {
      let fetchInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calendarEvents.defaultFetchInfo;

      _classPrivateMethodGet(this, _checkValidProfiles, _checkValidProfiles2).call(this);

      const {
        fullCalendar
      } = this.calendarConfig;
      const events = yield (0, _emberConcurrencyTs.taskFor)(this._fetchPostEvents).perform(fetchInfo);
      (0, _emberConcurrencyTs.taskFor)(this.calendarEvents.prefetch).perform(fetchInfo.start);
      yield fullCalendar === null || fullCalendar === void 0 ? void 0 : fullCalendar.removeAllEvents();
      yield fullCalendar === null || fullCalendar === void 0 ? void 0 : fullCalendar.addEventSource(events);
    }

    *_fetchPostEvents() {
      let fetchInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calendarEvents.defaultFetchInfo;
      const events = yield (0, _emberConcurrencyTs.taskFor)(this.calendarEvents.getEvents).perform(this.cachedData, fetchInfo);
      return (0, _utils.isEmpty)(events) ? [] : events.filter(event => event.eventType === POST);
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "calendarMarkup", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "calendarEvents", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "firstDay", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "currentUserModel", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "timeZone", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "profiles", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "timeZoneIdentifier", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "timeZoneName", [_dec10], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "createCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateEvents", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_addEventsToCalendar", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_addEventsToCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_handleDateSet", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_handleDateSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateEvents", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "_updateEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_fetchPostEvents", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_fetchPostEvents"), _class.prototype)), _class));
  _exports.default = StoriesFullCalendarComponent;

  function _updateCalendarDates2(start, end) {
    if (typeof this.args.updateTargetDate === 'function') {
      this.args.updateTargetDate(start);
    }

    this.calendarConfig.startTime = start;
    this.calendarConfig.endTime = end;
  }

  function _checkValidProfiles2() {
    if (!this.socialProfile.isInstagram || this.selectedSocialProfiles.hasMultipleSelected) {
      this.alerts.warning(this.intl.t('alerts.stories.only_with_instagram.message'), {
        title: this.intl.t('alerts.stories.only_with_instagram.title')
      }); // Note: Required for circumstances where the social profile would update during an aborted transition in
      // app/routes/cluster/schedule/stories.js

      if (!this.dialogManager.showConfirmationModal) {
        this.router.transitionTo('account.groups.group.social_profiles', this.auth.currentGroup.id);
      }
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StoriesFullCalendarComponent);
});